import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { JsxFragment } from "../JsxFragment";
import { ITableColumnBase, TableColumnBase, TableColumnBasePropertyValues } from "./Table";
import { TableCellEntityAction } from "./TableCellEntityAction";
import { NAMESPACE } from "./_Namespace";

import "./TableColumnEntityAction.scss";

export type TableColumnEntityActionPropertyValues =
    TableColumnBasePropertyValues
    & {
    };

export type TableColumnEntityActionProperties = {
    [name in keyof TableColumnEntityActionPropertyValues]: Property<TableColumnEntityActionPropertyValues[name]>
};

export interface ITableColumnEntityAction extends ITableColumnBase, TableColumnEntityActionProperties
{
}

export class TableColumnEntityAction extends TableColumnBase implements ITableColumnEntityAction
{
    // #region Static

    public static override classNamespace = NAMESPACE + "TableColumnEntityAction";
    public static override className = "TableColumnEntityAction";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<TableColumnEntityActionPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                tableCellClass: TableCellEntityAction,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TableColumnEntityActionPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-table-column-entity-action rad-device-visible-when-narrow");
    }

    // #endregion

    // #region Overrides

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <th ref={this._containerElementRef}>
                {children ?? this._createChildrenHtml()}
            </th>
        );
    }

    // #endregion

    // #endregion
}

